import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/productos',documento:'catalogs',acceso:'sesion',filas:['058'],cita:'Areas/Catalogs/Controllers/ProductsController.cs:73'} satisfies RutaProd;
